
export default {
  props: {
    text: {
      // 提示信息
      type: String,
      default: '数据请求中...'
    },
    height: {
      // 高度
      type: String,
      default: 'auto'
    },
    bg: {
      // 背景色
      type: String,
      default: 'rgba(0, 0, 0, 0.3)'
    }
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    open() {
      this.show = true
    },

    close() {
      this.show = false
    }
  }
}
